import { render, staticRenderFns } from "./notice_view.vue?vue&type=template&id=5d90f800&"
import script from "./notice_view.vue?vue&type=script&lang=js&"
export * from "./notice_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports